import React, { useMemo } from 'react';
import { useField } from 'formik';

import { BaseSelect } from '../shared/BaseSelect/BaseSelect';

import styles from './FormikMultiSelectInput.module.scss';

export const FormikMultiSelectInput = ({
  name,
  options,
  label,
  placeholder,
  isRequired,
  isClearable = true,
  shouldDisplayLabel = true,
  controlShouldRenderValue = true,
  ...props
}) => {
  const [field, meta, helpers] = useField(name);
  const values = useMemo(() => {
    if (!field.value || !Array.isArray(field.value)) {
      return [];
    }
    return options.filter((opt) => field.value.includes(opt.value));
  }, [field.value, options]);

  return (
    <div className={styles.container}>
      {shouldDisplayLabel && (
        <label htmlFor={name} className={styles.label}>
          {label} {isRequired && <span className={styles.required}>*</span>}
        </label>
      )}
      <BaseSelect
        {...meta}
        isMulti
        closeMenuOnSelect={false}
        placeholder={placeholder}
        onChange={(selectedOptions) => helpers.setValue(selectedOptions.map((opt) => opt.value))}
        value={values}
        options={options}
        isClearable={isClearable}
        controlShouldRenderValue={controlShouldRenderValue}
        menuMaxHeight="300px"
        hideSelectedOptions={false}
        hasError={meta.touched && meta.error}
        {...props}
      />
      {meta.touched && meta.error && <div className={styles.errorMessage}>{meta.error}</div>}
    </div>
  );
};
